import 'jquery';

/**
 * handle browser back
 */
(function (document, history, $) {
  // catch every browser back
  window.onpopstate = function (event) {
    // we should show the correct route here
    let backUrl = $('body').data('back');

    // going back
    if (backUrl) {
      location.href = backUrl;
    }

    console.log('location: ' + document.location + ', state: ' + JSON.stringify(event.state));
  };

  history.replaceState({page: 1}, 'title 1', '#backStop');

}(document, history, jQuery));
